import styled from 'styled-components';

export const Container = styled.div`
  .chart-legend {
    .apexcharts-legend {
      white-space: nowrap;
      width: 200px;
      /* overflow: scroll; */
    }

    @media (max-width: 992px) {
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      flex-direction: row;
      height: auto;
      width: 100%;
    }
  }
`;

export const ChartCard = styled.section`
  width: 100%;
  border: 1px solid #eceeef;
  border-radius: 0.2rem;
  margin: 2rem 0.5rem;
  padding: 24px;
  position: relative;
  box-sizing: border-box;

  .apexcharts-toolbar {
    position: absolute;
    top: -173px !important;
    right: -6px !important;
  }

  .apexcharts-canvas,
  .apexcharts-canvas > svg,
  foreignObject {
    width: 100% !important;
  }

  .apexcharts-canvas text {
    font-family: ${props => props.theme.fontDefault}!important;
  }

  .apexcharts-legend.apexcharts-align-center.position-bottom {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .apexcharts-zoom-icon svg,
  .apexcharts-zoomin-icon svg,
  .apexcharts-zoomout-icon svg,
  .apexcharts-reset-icon svg,
  .apexcharts-menu-icon svg {
    fill: #555;
  }
`;

export const ContainerFilter = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 1rem 0rem;

  .field-select {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-left: 0.2rem;

    .react-select__control {
      display: flex;
      width: 90px;
      padding-top: 6px;
      padding-bottom: 6px;

      @media (max-width: 992px) {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
      }
    }
  }

  @media (max-width: 992px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: auto;
    width: 100%;
  }
`;

export const ActionsForm = styled.div`
  margin-top: 2.77rem;
  margin-left: 1rem;

  @media (max-width: 992px) {
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    margin-top: unset;
    margin-left: unset;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;

  @media (max-width: 992px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`;
